import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { GridPanelName } from 'features/layout/features/content/types';
import { ExternalStreamSourceDetails, ScreenshareSourceDetails } from 'features/layout/types';

export function findLatestOpenedContent(
  lastOpenedExternalStream: ExternalStreamSourceDetails,
  lastOpenedScreenshare: ScreenshareSourceDetails,
  lastOpenedFile: ContentLibraryOpenedFile,
  lastOpenedWhiteboard: ContentLibraryOpenedFile
): GridPanelName | null {
  let latestTimestamp: number = 0;
  let latestContent: GridPanelName | null = null;

  if (lastOpenedExternalStream?.timestamp > latestTimestamp) {
    latestTimestamp = lastOpenedExternalStream.timestamp;
    latestContent = 'external';
  }

  if (lastOpenedScreenshare?.timestamp > latestTimestamp) {
    latestTimestamp = lastOpenedScreenshare.timestamp;
    latestContent = 'screenshare';
  }

  if (lastOpenedFile && new Date(lastOpenedFile.date).getTime() > latestTimestamp) {
    latestTimestamp = new Date(lastOpenedFile.date).getTime();
    latestContent = 'contentLibrary';
  }

  if (lastOpenedWhiteboard && new Date(lastOpenedWhiteboard.date).getTime() > latestTimestamp) {
    latestContent = 'whiteboard';
  }

  return latestContent;
}
